module.exports = __webpack_public_path__ + "static/img/sbjkfx-title.85e5d91.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/xiayan/assets/img/sbjkfx-title.png
// module id = Px5l
// module chunks = 1